const OPENTOK_SCRIPT_URL = 'https://static.opentok.com/v2/js/opentok.min.js'

const LOAD_TIMEOUT_MS = 15000

let loadingPromise = null

export default function loadOpenTok() {
  if (window.OT) return Promise.resolve(window.OT)
  if (loadingPromise) return loadingPromise

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = OPENTOK_SCRIPT_URL
    let timeoutId = null
    let settled = false
    const fail = (message) => {
      if (settled) return
      settled = true
      clearTimeout(timeoutId)
      loadingPromise = null
      script.remove()
      reject(new Error(message))
    }
    timeoutId = setTimeout(() => fail('Timed out loading the OpenTok SDK'), LOAD_TIMEOUT_MS)
    script.onload = () => {
      if (settled) return
      if (!window.OT) {
        fail('The OpenTok SDK loaded without defining window.OT')
        return
      }
      settled = true
      clearTimeout(timeoutId)
      resolve(window.OT)
    }
    script.onerror = () => fail('Failed to load the OpenTok SDK')
    document.body.appendChild(script)
  })
  return loadingPromise
}
